<script setup>
import { ref, reactive, onBeforeMount, nextTick } from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import YTI18NTabs from "@/components/YTIN18Tabs/index.vue";
import BoxUpload from "@/components/YTBoxUpload/newIndex.vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import validatorRules from "@/utils/validator-rules.js";
import YTAddress from "@/components/YTAddress/newIndex.vue";
import YTAvatarUpload from "@/components/YTAvatarUpload/index.vue";
import YTDialog from "@/components/YTDialog/index.vue";
import YTTab from "@/components/YTTab/index.vue";
import {
  addClub,
  getClub,
  editClubInfo,
  editPersonInfo,
  api_albumCollectList,
  api_albumShowList,
  api_cancelCollectActivityPhoto,
  api_setAlbumShow,
  api_cancelAlbumShow,
  api_uploadAlbumShow,
} from "@/api/club/club.js";
import { userInfoStore } from "@/store/store.js";

// 上传失败
const handlePicFail = () => {
  album_loading.value = false;
};
// 上传中
const handlePicProgress = () => {
  album_loading.value = true;
};
// 上传成功
const handleAlbumSuccess = async (photo_arr) => {
  try {
    const album_list = [...photo_arr];
    console.log("album_list: ", album_list);
    await Promise.all(
      album_list.map((item) =>
        api_uploadAlbumShow({
          storeId: userInfo.value.storeId,
          albumImage: item[0],
        })
      )
    );
    await getAlbumShowList();
  } catch (err) {
    console.log(err);
    album_loading.value = false;
  }
};

// 用户信息
const userInfo = ref(userInfoStore().info);
// 路由信息
import { getRoute } from "@/hooks/getRoute.js";
const { route } = getRoute();

// 相册相关
const album_loading = ref(false);
const album_list = reactive([]);
const album_page_params = reactive({
  pageNum: 1,
  pageSize: 20,
});
const album_show_list = reactive([]);
const album_total = ref(0);
const albumPaginationRef = ref();

// 图片预览相关
const dialogImageUrl = ref("");
const dialogVisible = ref(false);

const cancel_collect_show = ref(false);

const cancel_albumImageId = ref(0);

onBeforeMount(async () => {
  console.log("route", route.path === "/club/editClub");
  isEdit.value = true;

  await getDetail(userInfo.value.storeId);
  await getAlbumCollectList();
});

const showCCDialog = async (id) => {
  cancel_albumImageId.value = id;
  cancel_collect_show.value = true;
};

const deleteAlbumShowImage = async (id) => {
  try {
    album_loading.value = true;
    await api_cancelAlbumShow({
      albumImageId: id,
      storeId: userInfo.value.storeId,
    });
    await getAlbumShowList();
    await getAlbumCollectList();
    album_loading.value = false;
    ElMessage.success("已取消主页展示");
  } catch (error) {
    console.log(error);
    album_loading.value = false;
    ElMessage.error("取消主页展示失败");
  }
};

const cancelCollectAlbum = async () => {
  try {
    cancel_collect_show.value = false;
    album_loading.value = true;
    await api_cancelCollectActivityPhoto({
      albumImageId: cancel_albumImageId.value,
      storeId: userInfo.value.storeId,
    });
    await getAlbumCollectList();
    await getAlbumShowList();
    album_loading.value = false;
    ElMessage.success("已取消收藏");
  } catch (error) {
    console.log(error);
    cancel_collect_show.value = false;
    album_loading.value = false;
    ElMessage.error("取消收藏失败");
  }
};

const useAlbum = async (item) => {
  if (item.isHomepageDisplay) {
    return;
  }
  try {
    album_loading.value = true;
    await api_setAlbumShow({
      storeId: userInfo.value.storeId,
      albumImageId: item.albumImageId,
    });
    await getAlbumCollectList();
    await getAlbumShowList();
    album_loading.value = false;
    ElMessage.success("已使用");
  } catch (error) {
    console.log(error);
    ElMessage.error("使用失败");
    album_loading.value = false;
  }
};

const getAlbumShowList = async () => {
  try {
    album_loading.value = true;
    const res = await api_albumShowList({
      storeId: userInfo.value.storeId,
    });
    Object.assign(album_show_list, res);
    album_show_list.length = 0;
    album_show_list.push(...res);
    album_loading.value = false;
  } catch (error) {
    console.log(error);
    album_loading.value = false;
  }
};

const getAlbumCollectList = async () => {
  try {
    album_loading.value = true;
    const res = await api_albumCollectList(
      album_page_params,
      userInfo.value.storeId
    );
    album_list.length = 0; // 清空数组
    album_list.push(...res.list); // 添加新元素
    album_total.value = res.total || 0; // 设置总数
    album_loading.value = false;
  } catch (error) {
    console.log(error);
    album_loading.value = false;
  }
};

// 相册收藏列表分页事件处理
const handleAlbumPageChange = () => {
  album_page_params.pageNum = albumPaginationRef.value.getPage();
  album_page_params.pageSize = albumPaginationRef.value.getPageSize();
  getAlbumCollectList();
};

// 显示图片预览
const showPreview = (item) => {
  dialogImageUrl.value = item.albumImage;
  dialogVisible.value = true;
};

// 获取详情信息
const getDetail = async (info) => {
  open.value = true;
  try {
    loading.value = true;
    const res = await getClub(info);
    isEdit.value = true;
    loading.value = false;
    console.log(res);
    Object.assign(ruleForm, res);
    // 特殊处理地址反显
    let temp = [];
    if (ruleForm.address) {
      temp.push(ruleForm.address.provinceCode);
      temp.push(ruleForm.address.cityCode);
      temp.push(ruleForm.address.districtCode);
      ruleForm.showAddressCode = temp;
    }
    console.log("temp", temp);
    console.log("ruleForm.address", ruleForm.address);
    console.log("ruleForm.showAddressCode", ruleForm.showAddressCode);
    handleReviewPic([res.storeLogo]);
    nextTick(() => {
      // 反显人员头像
      handleReviewPersonnelInfoUploadPic(ruleForm.personnelInfo);
    });
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

// 是否为修改模式
const isEdit = ref(false);
// 加载状态
const loading = ref(false);
// 表单锚点
const ruleFormRef = ref();
// 表单信息
const ruleForm = reactive({
  storeLogo: null,
  storeId: null,
  name: null,
  nameEn: "Coming Soon ...",
  summary: null,
  summaryEn: "Coming Soon ...",
  description: null,
  descriptionEn: "Coming Soon ...",
  phone: null,
  showAddressCode: null,
  address: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null,
  },
  contactName: null,
  personnelInfo: [
    {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ...",
        },
      ],
    },
  ],
});
// 俱乐部logo校验规则
const checkImagesList = (rule, value, callback) => {
  handleSubmitDisabled_tab1();
  const listLength = boxUploadRef.value.fileList.length;
  if (listLength < 1) {
    return callback(new Error("请上传一张俱乐部Logo"));
  }
  callback();
};
// 俱乐部名称校验规则
const checkClubName = (rule, value, callback) => {
  handleSubmitDisabled_tab1();
  if (!ruleForm.name) {
    return callback(new Error("俱乐部名称（中文）不能为空！"));
  }
  if (!ruleForm.nameEn) {
    return callback(new Error("俱乐部名称（English）不能为空！"));
  }
  return callback();
};
// 俱乐部简介校验规则
const checkSummary = (rule, value, callback) => {
  handleSubmitDisabled_tab1();
  if (!ruleForm.summary) {
    return callback(new Error("俱乐部简介（中文）不能为空！"));
  }
  if (!ruleForm.summaryEn) {
    return callback(new Error("俱乐部简介（English）不能为空！"));
  }
  return callback();
};
// 俱乐部描述校验规则
const checkDescription = (rule, value, callback) => {
  handleSubmitDisabled_tab1();
  if (!ruleForm.description) {
    return callback(new Error("俱乐部描述（中文）不能为空！"));
  }
  if (!ruleForm.descriptionEn) {
    return callback(new Error("俱乐部描述（English）不能为空！"));
  }
  return callback();
};
// 手机号校验规则
const checkPhone = (rule, value, callback) => {
  handleSubmitDisabled_tab1();
  if (!value) {
    // 应Pat要求，只做联系电话空校验，因为需要400这种联系电话
    return callback(new Error("联系电话不能为空！"))
    // if (!validatorRules.isPhone(value)) {
    //   callback(new Error("手机号码格式不正确"));
    // }
  }
  return callback();
};
// 俱乐部地址校验规则
const checkAddress = (rule, value, callback) => {
  handleSubmitDisabled_tab1();
  if (!ruleForm.showAddressCode) return callback(new Error("请选择俱乐部地址"));
  return callback();
};
// 俱乐部人员头像校验规则
const checkPersonnelAvatar = (rule, value, callback) => {
  handleSubmitDisabled();
  for (let i = 0; i < ruleForm.personnelInfo.length; i++) {
    console.log("[i]", i);
    console.log("ruleForm.personnelInfo[i]", ruleForm.personnelInfo[i]);
    if (
      !ruleForm.personnelInfo[i].avatar &&
      !boxUploadAvatarRef.value[i].isChange
    ) {
      return callback(new Error(`主理人信息中第${i + 1}项人员头像未上传`));
    }
  }
  return callback();
};
// 俱乐部人员名称校验规则
const checkPersonnelName = (rule, value, callback) => {
  for (let i = 0; i < ruleForm.personnelInfo.length; i++) {
    if (!ruleForm.personnelInfo[i].name) {
      console.log(
        "ruleForm.personnelInfo[i].name",
        ruleForm.personnelInfo[i].name
      );
      return callback(
        new Error(`主理人信息中第${i + 1}项人员名称（中文）未填写`)
      );
    }
    if (!ruleForm.personnelInfo[i].nameEn) {
      return callback(
        new Error(`主理人信息中第${i + 1}项人员名称（English）未填写`)
      );
    }
  }
  return callback();
};
// 俱乐部人员简介校验规则
const checkSummaryInfo = (rule, value, callback) => {
  handleSubmitDisabled();
  for (let i = 0; i < ruleForm.personnelInfo.length; i++) {
    for (let j = 0; j < ruleForm.personnelInfo[i].summaryInfo.length; j++) {
      if (!ruleForm.personnelInfo[i].summaryInfo[j].summary) {
        return callback(
          new Error(
            `主理人信息中第${i + 1}项的第${j + 1}人员简介（中文）未填写`
          )
        );
      }
      if (!ruleForm.personnelInfo[i].summaryInfo[j].summaryEn) {
        return callback(
          new Error(
            `主理人信息中第${i + 1}项的第${j + 1}人员简介（English）未填写`
          )
        );
      }
    }
  }
  return callback();
};

// 表单校验规则
const rules1 = {
  storeLogo: [
    { required: true, validator: checkImagesList, trigger: "change" },
  ],
  name: [{ required: true, validator: checkClubName, trigger: "change" }],
  summary: [{ required: true, validator: checkSummary, trigger: "change" }],
  description: [
    { required: true, validator: checkDescription, trigger: "change" },
  ],
  phone: [{ required: true, validator: checkPhone, trigger: "change" }],
  address: [{ required: true, validator: checkAddress, trigger: "change" }],
  contactName: [
    { required: true, message: "请输入负责人", trigger: "blur" }
  ]
};

const rules2 = {
  personnelInfo: {
    avatar: [{ required: true, validator: checkPersonnelAvatar }],
    name: [
      { required: true, validator: checkPersonnelName, trigger: "change" },
    ],
    summaryInfo: [
      { required: true, validator: checkSummaryInfo, trigger: "change" },
    ],
  },
};

const rules = ref(rules1);

/*添加主理人信息相关*/
// 增加人员简介
const handleAddDesc = (item) => {
  if (item.summaryInfo.length >= 3) {
    return ElMessage.error("人员简介最多三条");
  }
  item.summaryInfo.push({
    summary: null,
    summaryEn: "Coming Soon ...",
  });
  handleSubmitDisabled();
};
// 删除人员简介
const handleRemoveSummary = (index, sonIndex) => {
  ruleForm.personnelInfo[index].summaryInfo.splice(sonIndex, 1);
  handleSubmitDisabled();
  ruleFormRef.value.validateField("personnelInfo.summaryInfo");
};
// 增加人员
const handleAddMember = () => {
  handleSubmitDisabled();
  if (ruleForm.personnelInfo.length >= 3) {
    return ElMessage.error("最多添加三人！");
  }
  ruleForm.personnelInfo.push({
    avatar: null,
    name: null,
    nameEn: "Coming Soon ...",
    summaryInfo: [
      {
        summary: null,
        summaryEn: "Coming Soon ...",
      },
    ],
  });
};
// 删除主理人信息
const handleRemovePersonnelInfo = (index) => {
  ruleForm.personnelInfo.splice(index, 1);
  handleSubmitDisabled();
  nextTick(() => {
    // 反显人员头像
    handleReviewPersonnelInfoUploadPic(ruleForm.personnelInfo);
  });
};
/*上传图片组件相关*/
// Logo图片上传组件锚点
const boxUploadRef = ref();
const handlePicSuccess = (url) => {
  ruleForm.storeLogo = null;
  ruleForm.storeLogo = url[0];
  ruleFormRef.value.validateField("storeLogo");
  loading.value = false;
};
// 处理Logo图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList);
};
// 处理人员头像反显
const handleReviewPersonnelInfoUploadPic = (reviewList) => {
  boxUploadAvatarRef.value.forEach((item, index) => {
    if (reviewList[index]?.avatar) {
      item.handleReview([reviewList[index]?.avatar]);
    } else {
      item.handleClearList();
    }
  });
};
// 人员头像锚点
const boxUploadAvatarRef = ref([]);
// 处理主理人信息头像上传成功
const handlePersonnelAvatarSuccess = (url, index) => {
  console.log(`第${index + 1}个人员头像上传成功`);
  // 更新表单数据
  if (!ruleForm.personnelInfo[index]) {
    ruleForm.personnelInfo[index] = {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ...",
        },
      ],
    };
  }
  ruleForm.personnelInfo[index].avatar = url[0];
  ruleFormRef.value.validateField("personnelInfo.avatar");
  loading.value = false;
};
// 处理主理人信息头像删除
const handlePersonnelAvatarRemove = (url, index) => {
  ruleForm.personnelInfo[index].avatar = url[0];
  ruleFormRef.value.validateField("personnelInfo.avatar");
};
/*选择地址相关*/
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data);
  ruleForm.addressCode = data.value;
  ruleForm.address.provinceCode = data.value[0];
  ruleForm.address.cityCode = data.value[1];
  ruleForm.address.districtCode =
    data.value.length === 3 ? data.value[2] : null;
  ruleForm.showAddressCode = data.value.join("/");
  ruleFormRef.value.validateField("address");
};

/*中英文切换输入框相关Tab*/
// 俱乐部名称tab
const clubNameTab = ref("zh");
// 俱乐部简介tab
const clubSummaryTab = ref("zh");
// 俱乐部描述tab
const clubDescTab = ref("zh");
// 俱乐部地址tab
const clubStreetTab = ref("zh");
// 人员名称tab
const memberAvatarTab = ref(["zh", "zh", "zh"]);
// 人员简介tab
const memberDescTab = ref([
  ["zh", "zh", "zh"],
  ["zh", "zh", "zh"],
  ["zh", "zh", "zh"],
]);

// 保存校验表单
const submit = async () => {
  try {
    if (ruleForm.personnelInfo.length <= 0) {
      return ElMessage.error("至少添加一条主理人信息");
    }
    console.log("ruleForm", ruleForm);
    ruleFormRef.value.validate(async (valid) => {
      if (valid) {
        loading.value = true;
        createClub();
        console.log("ruleForm", ruleForm);
      } else {
        ElMessage({
          message: "请根据提示修改表单信息",
          type: "error",
        });
        console.log("run in else");
      }
      loading.value = false;
    });
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

// 创建/修改俱乐部
const createClub = async () => {
  try {
    console.log("isEdit.value", isEdit.value);
    loading.value = true;
    let res = null;
    if (isEdit.value) {
      // res = await editClub(ruleForm.storeId, ruleForm);
      if (tab_selected.value === 0) {
        res = await editClubInfo(ruleForm.storeId, ruleForm);
      } else if (tab_selected.value === 1) {
        res = await editPersonInfo(ruleForm.storeId, ruleForm);
      }
    } else {
      res = await addClub(ruleForm);
    }
    ElMessage.success(isEdit.value ? "修改俱乐部成功" : "新建俱乐部成功");
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};
const handleSubmitDisabled_tab1 = () => {
  submitDisabled_tab1.value =
    boxUploadRef.value.fileList.length === 0 ||
    ruleForm.name === null ||
    ruleForm.nameEn === null ||
    ruleForm.summary === null ||
    ruleForm.summaryEn === null ||
    ruleForm.description === null ||
    ruleForm.descriptionEn === null ||
    (ruleForm.phone === null || ruleForm.phone === "") ||
    ruleForm.showAddressCode === null ||
    (ruleForm.contactName === null || ruleForm.contactName === "")
};
// 处理按钮是否禁用
const handleSubmitDisabled = () => {
  let personnelAvatarPass = true;
  let personnelNamePass = true;
  let personnelSummaryPass = true;
  for (let i = 0; i < ruleForm.personnelInfo.length; i++) {
    if (
      !ruleForm.personnelInfo[i].avatar &&
      !boxUploadAvatarRef.value[i].isChange
    ) {
      personnelAvatarPass = false;
    }
    if (!ruleForm.personnelInfo[i].name || !ruleForm.personnelInfo[i].nameEn) {
      personnelNamePass = false;
    }
    for (let j = 0; j < ruleForm.personnelInfo[i].summaryInfo.length; j++) {
      if (
        !ruleForm.personnelInfo[i].summaryInfo[j].summary ||
        !ruleForm.personnelInfo[i].summaryInfo[j].summaryEn
      ) {
        personnelSummaryPass = false;
      }
    }
  }
  submitDisabled.value =
    boxUploadRef.value.fileList.length === 0 ||
    ruleForm.name === null ||
    ruleForm.nameEn === null ||
    ruleForm.summary === null ||
    ruleForm.summaryEn === null ||
    ruleForm.description === null ||
    ruleForm.descriptionEn === null ||
    (ruleForm.phone === null || ruleForm.phone === "") ||
    ruleForm.showAddressCode === null ||
    (ruleForm.contactName === null || ruleForm.contactName === "") ||
    ruleForm.personnelInfo.length <= 0 ||
    !personnelAvatarPass ||
    !personnelNamePass ||
    !personnelSummaryPass;
};

// 发布按钮禁用状态
const submitDisabled = ref(true);
const submitDisabled_tab1 = ref(true);

// tab相关
const tabs_list = reactive([
  {
    id: 0,
    title: "账号基础信息",
    show: true,
  },
  {
    id: 1,
    title: "主理人信息",
    show: true,
  },
  {
    id: 2,
    title: "相册管理",
    show: true,
  },
]);
const tab_selected = ref(0);

const tabSelected = async (selected_id) => {
  tab_selected.value = selected_id;
  if (selected_id === 0) {
    rules.value = rules1;
  } else if (selected_id === 1) {
    rules.value = rules2;
  } else if (selected_id === 2) {
    try {
      await getAlbumCollectList();
      await getAlbumShowList();
    } catch (error) {
      console.log(error);
    }
  } else {
    return;
  }
};
</script>

<template>
  <div
    class="new_container_box"
    style="box-sizing: border-box; padding: 46px 75px 20px"
  >
    <YTTab :tab_list="tabs_list" @selected="tabSelected"></YTTab>

    <div class="tab_page mt36 pb300">
      <div v-show="tab_selected === 0">
        <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          v-loading="loading"
        >
          <YTCard
            :class="isEdit ? 'edit_title' : ''"
            :title="'账号基础信息'"
            :is-show-divider="true"
          >
            <template #container>
              <el-form-item prop="storeLogo">
                <YTAvatarUpload :ali-oss-path="'STORE_LOGO'"
                  ref="boxUploadRef"
                  :isReplaceMode="true"
                  :isLogoMode="true"
                  :limit="1"
                  :width="80"
                  :height="80"
                  :file-size="1"
                  :isRequired="true"
                  :tips="`添加俱乐部logo，照片会显示在你使用的账号平台上。`"
                  @progress="loading = true"
                  @success="handlePicSuccess"
                ></YTAvatarUpload>
              </el-form-item>
              <el-form-item label="俱乐部名称：" prop="name">
                <div class="flex">
                  <el-input
                    maxlength="20"
                    show-word-limit
                    v-if="clubNameTab === 'zh'"
                    v-model="ruleForm.name"
                    :class="
                      ruleForm.name === null || ruleForm.name === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="输入俱乐部名称"
                  ></el-input>
                  <el-input
                    maxlength="60"
                    show-word-limit
                    v-if="clubNameTab === 'en'"
                    v-model="ruleForm.nameEn"
                    :class="
                      ruleForm.nameEn === null || ruleForm.nameEn === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="输入俱乐部名称"
                  ></el-input>
                  <YTI18NTabs v-model="clubNameTab"></YTI18NTabs>
                </div>
              </el-form-item>
              <el-form-item label="简介：" prop="summary">
                <el-input
                  v-if="clubSummaryTab === 'zh'"
                  maxlength="100"
                  show-word-limit
                  v-model="ruleForm.summary"
                  :class="
                    ruleForm.summary === null || ruleForm.summary === ''
                      ? 'input-null mg_r_2'
                      : 'input-filled mg_r_2'
                  "
                  style="width: 408px; margin-right: 15px"
                  placeholder="输入一句话介绍俱乐部"
                ></el-input>
                <el-input
                  v-if="clubSummaryTab === 'en'"
                  maxlength="300"
                  show-word-limit
                  v-model="ruleForm.summaryEn"
                  :class="
                    ruleForm.summaryEn === null || ruleForm.summaryEn === ''
                      ? 'input-null mg_r_2'
                      : 'input-filled mg_r_2'
                  "
                  style="width: 408px; margin-right: 15px"
                  placeholder="输入一句话介绍俱乐部"
                ></el-input>
                <YTI18NTabs v-model="clubSummaryTab"></YTI18NTabs>
              </el-form-item>
              <el-form-item label="描述：" prop="description">
                <div class="flex_align_t">
                  <el-input
                    type="textarea"
                    maxlength="200"
                    v-if="clubDescTab === 'zh'"
                    resize="none"
                    :rows="5"
                    show-word-limit
                    v-model="ruleForm.description"
                    :class="
                      ruleForm.description === null ||
                      ruleForm.description === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="输入一段话描述俱乐部"
                  ></el-input>
                  <el-input
                    type="textarea"
                    maxlength="600"
                    v-if="clubDescTab === 'en'"
                    resize="none"
                    :rows="5"
                    show-word-limit
                    v-model="ruleForm.descriptionEn"
                    :class="
                      ruleForm.descriptionEn === null ||
                      ruleForm.descriptionEn === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="输入一段话描述俱乐部"
                  ></el-input>
                  <YTI18NTabs v-model="clubDescTab"></YTI18NTabs>
                </div>
              </el-form-item>
              <el-form-item label="联系电话：" prop="phone">
                <el-input
                  maxlength="11"
                  show-word-limit
                  v-model="ruleForm.phone"
                  :class="
                    ruleForm.phone === null || ruleForm.phone === ''
                      ? 'input-null'
                      : 'input-filled'
                  "
                  style="width: 408px; margin-right: 15px"
                  placeholder="输入俱乐部联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="地址：" prop="address">
                <div class="flex">
                  <div>
                    <YTAddress
                      style="width: 196px"
                      :placeholder="`选择所属区域`"
                      class="mg_r_2"
                      :addressCode="ruleForm.showAddressCode"
                      @select="handleSelectAddress"
                    ></YTAddress>
                  </div>
                  <el-input
                    v-if="clubStreetTab === 'zh'"
                    v-model="ruleForm.address.addressDetail"
                    :class="
                      ruleForm.address.addressDetail === null ||
                      ruleForm.address.addressDetail === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="详细地址，例如街道门牌号"
                  ></el-input>
                  <el-input
                    v-if="clubStreetTab === 'en'"
                    v-model="ruleForm.address.addressDetailEn"
                    :class="
                      ruleForm.address.addressDetailEn === null ||
                      ruleForm.address.addressDetailEn === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="详细地址，例如街道门牌号"
                  ></el-input>
                  <YTI18NTabs v-model="clubStreetTab"></YTI18NTabs>
                </div>
              </el-form-item>
              <el-form-item label="负责人：" prop="contactName">
                <el-input v-model="ruleForm.contactName" :class="ruleForm.contactName === null || ruleForm.contactName === '' ? 'input-null' : 'input-filled'" style="width:408px;margin-right: 15px;" placeholder="输入负责人" @change="handleSubmitDisabled_tab1"></el-input>
              </el-form-item>
            </template>
          </YTCard>
          <div class="w-100 flex_right">
            <v-btn
              class="submit_btn"
              color="#4CAF50"
              :disabled="submitDisabled_tab1"
              @click="submit"
              >提交资料</v-btn
            >
          </div>
        </el-form>
      </div>
      <div v-show="tab_selected === 1">
        <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          v-loading="loading"
        >
          <YTCard
            :class="isEdit ? 'edit_title' : ''"
            :title="'主理人信息'"
            :is-show-divider="false"
          >
            <template #container>
              <div
                v-for="(item, index) in ruleForm.personnelInfo"
                :key="`personnelInfo${index}`"
              >
                <el-form-item prop="personnelInfo.avatar">
                  <div class="flex_bt" style="width: 680px">
                    <div>
                      <YTAvatarUpload :ali-oss-path="'PERSONNEL_INFO_AVATAR_PATH'"
                        :isReplaceMode="true"
                        :ref="
                          (el) => {
                            if (el) boxUploadAvatarRef[index] = el;
                          }
                        "
                        :isLogoMode="false"
                        :limit="1"
                        :width="80"
                        :height="80"
                        :file-size="1"
                        :isRequired="true"
                        :tips="``"
                        @progress="loading = true"
                        @success="
                          (url) => handlePersonnelAvatarSuccess(url, index)
                        "
                        @remove="
                          (url) => handlePersonnelAvatarRemove(url, index)
                        "
                      ></YTAvatarUpload>
                    </div>
                    <div
                      v-if="ruleForm.personnelInfo.length > 1"
                      class="flex_center cursor-pointer"
                      @click="handleRemovePersonnelInfo(index)"
                    >
                      <img
                        style="width: 25px; height: 25px; margin-right: 11px"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/remove_member.svg"
                      />
                      <div class="add_member_tips_member">删除成员</div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="人员名称：" prop="personnelInfo.name">
                  <el-input
                    v-if="memberAvatarTab[index] === 'zh'"
                    v-model="item.name"
                    :class="
                      item.name === null || item.name === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="输入人员名称"
                  ></el-input>
                  <el-input
                    v-if="memberAvatarTab[index] === 'en'"
                    v-model="item.nameEn"
                    :class="
                      item.nameEn === null || item.nameEn === ''
                        ? 'input-null mg_r_2'
                        : 'input-filled mg_r_2'
                    "
                    style="width: 408px; margin-right: 15px"
                    placeholder="输入人员名称"
                  ></el-input>
                  <YTI18NTabs v-model="memberAvatarTab[index]"></YTI18NTabs>
                </el-form-item>
                <el-form-item
                  label="人员简介："
                  prop="personnelInfo.summaryInfo"
                >
                  <div>
                    <div
                      class="flex_center"
                      v-for="(sonItem, sonIndex) in item.summaryInfo"
                      style="margin-bottom: 15px"
                    >
                      <el-input
                        maxlength="40"
                        show-word-limit
                        v-if="memberDescTab[index][sonIndex] === 'zh'"
                        v-model="sonItem.summary"
                        :class="
                          sonItem.summary === null || sonItem.summary === ''
                            ? 'input-null mg_r_2'
                            : 'input-filled mg_r_2'
                        "
                        style="width: 408px; margin-right: 15px"
                        placeholder="建议输入人员在俱乐部的角色"
                      ></el-input>
                      <el-input
                        maxlength="40"
                        show-word-limit
                        v-if="memberDescTab[index][sonIndex] === 'en'"
                        v-model="sonItem.summaryEn"
                        :class="
                          sonItem.summaryEn === null || sonItem.summaryEn === ''
                            ? 'input-null mg_r_2'
                            : 'input-filled mg_r_2'
                        "
                        style="width: 408px; margin-right: 15px"
                        placeholder="建议输入人员在俱乐部的角色"
                      ></el-input>
                      <YTI18NTabs
                        v-model="memberDescTab[index][sonIndex]"
                        style="margin-right: 25px"
                      ></YTI18NTabs>
                      <img
                        v-if="item.summaryInfo.length > 1"
                        class="cursor-pointer"
                        style="width: 33px; height: 33px"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/delete.svg"
                        @click="handleRemoveSummary(index, sonIndex)"
                      />
                    </div>
                    <div>
                      <v-btn
                        rounded="xl"
                        color="#ECECF4"
                        @click="handleAddDesc(item)"
                      >
                        <template v-slot:default>
                          <div class="flex_bt">
                            <span style="color: #6f717d">新增介绍</span>
                            <img
                              style="
                                width: 14px;
                                height: 14px;
                                margin-left: 4px;
                              "
                              src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/plus_gray.svg"
                            />
                          </div>
                        </template>
                      </v-btn>
                    </div>
                  </div>
                </el-form-item>
                <el-divider style="margin: 40px 0" />
              </div>
              <div class="flex">
                <div class="flex cursor-pointer" @click="handleAddMember">
                  <img
                    style="width: 25px; height: 25px; margin-right: 11px"
                    src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/createClub/add_member.svg"
                  />
                  <div class="add_member_tips_member">
                    增加成员({{ ruleForm.personnelInfo.length }}/3)&emsp;
                  </div>
                </div>
                <div class="add_member_tips">最多可添加3名成员</div>
              </div>
            </template>
          </YTCard>
          <div class="w-100 flex_right">
            <v-btn
              class="submit_btn"
              color="#4CAF50"
              :disabled="submitDisabled"
              @click="submit"
              >提交资料</v-btn
            >
          </div>
        </el-form>
      </div>
      <div v-show="tab_selected === 2" v-loading="album_loading">
        <YTCard
          :class="isEdit ? 'edit_title' : ''"
          :title="'相册管理'"
          :is-show-divider="true"
        >
          <template #container>
            <div class="album_manage">
              <div class="collect">
                <div class="collect_title fwb">您的收藏</div>
                <div class="collect_list mt20">
                  <div
                    class="collect_item ml20 mb20"
                    v-for="(item, index) in album_list"
                    :key="index"
                    @click="showPreview(item)"
                  >
                    <div class="collect_item_inner">
                      <img class="image" :src="item.albumImage" alt="" />
                      <img
                        class="collected"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/collected.svg"
                        alt=""
                        @click.stop="showCCDialog(item.albumImageId)"
                      />
                    </div>

                    <div
                      :class="[
                        'use',
                        'mt10',
                        item.isHomepageDisplay ? 'is_used' : '',
                      ]"
                      @click.stop="useAlbum(item)"
                    >
                      {{ item.isHomepageDisplay ? "已使用" : "使用" }}
                    </div>
                  </div>
                </div>
                <!-- 分页组件 -->
                <YTTablePagination
                  v-if="album_total > 0"
                  ref="albumPaginationRef"
                  :pageSize="album_page_params.pageSize"
                  :total="album_total"
                  @page-change="handleAlbumPageChange"
                />
              </div>
              <div class="home_show">
                <div class="home_show_title fwb">主页展示</div>
                <div class="home_show_list mt20">
                  <div class="img_upload_info">
                    <BoxUpload
                      :limit="50"
                      :fileSize="3"
                      :ali-oss-path="'HOMEPAGE'"
                      :baseUrl="'/upload/uploadImgs'"
                      :isReplaceMode="false"
                      :showFileList="false"
                      :cache_type="false"
                      @success="handleAlbumSuccess"
                      @progress="handlePicProgress"
                      @fail="handlePicFail"
                    ></BoxUpload>
                  </div>
                  <div class="show_list ml20">
                    <div
                      class="show_item ml20 mb20"
                      v-for="(item, index) in album_show_list"
                      :key="index"
                      @click="showPreview(item)"
                    >
                      <img class="image" :src="item.albumImage" alt="" />
                      <img
                        class="del"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/img_del.svg"
                        alt=""
                        @click.stop="deleteAlbumShowImage(item.albumImageId)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </YTCard>
      </div>
    </div>
  </div>

  <!-- 图片预览对话框 -->
  <el-dialog v-model="dialogVisible" title="图片预览" width="50%">
    <div class="preview-container">
      <img
        :src="dialogImageUrl"
        alt="预览图片"
        style="width: 100%; height: auto"
      />
    </div>
  </el-dialog>

  <!-- 取消收藏二次确认弹窗 -->
  <YTDialog
    :open="cancel_collect_show"
    text="确认要取消收藏吗？"
    title="取消收藏"
    @confirm="cancelCollectAlbum"
    @cancel="cancel_collect_show = false"
  ></YTDialog>
</template>

<style lang="scss" scoped>
::v-deep(.el-input__wrapper) {
  height: 40px !important;
}
::v-deep(.el-input__suffix) {
  display: block !important;
}
.add_member_tips {
  font-weight: 500;
  font-size: 14px;
  color: #6f717d;
}
.add_member_tips_member {
  font-weight: 500;
  font-size: 14px;
  color: #684fa2;
}
.submit_btn {
  box-sizing: border-box;
  padding: 0 38px;
  height: 49px !important;
  font-size: 19px;
}
::v-deep(.edit_title) {
  .ytCard_box {
    .ytCard_title_box {
      .ytCard_title {
        font-size: 21px;
      }
    }
  }
}

.album_manage {
  .collect {
    .collect_list {
      display: flex;
      flex-wrap: wrap;
      .collect_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .collect_item_inner {
          width: 100px;
          height: 100px;
          position: relative;
          .image {
            width: 100px;
            height: 100px;

            object-fit: cover;
            object-position: center;
            background: #f6f6f6;
            border-radius: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }

          .collected {
            width: 33px;
            height: 26px;

            position: absolute;
            bottom: 1px;
            right: 1px;
          }
        }
        .use {
          text-align: center;
          background-color: #684fa2;
          padding: 5px 0px;
          width: 70%;
          border-radius: 20px;
          color: white;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
        }
        .is_used {
          background-color: #f6f6f6;
          color: black;
        }
      }
    }
  }
  .home_show {
    .home_show_list {
      display: flex;
      align-items: flex-start;
      .show_list {
        display: flex;
        flex-wrap: wrap;
        .show_item {
          position: relative;
          .image {
            width: 100px;
            height: 100px;

            object-fit: cover;
            object-position: center;
            background: #f6f6f6;
            border-radius: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
          .del {
            width: 30px;
            height: 30px;

            position: absolute;
            top: -10px;
            right: -10px;
          }
        }
      }
    }
  }
}
</style>
